import React from "react";
import { Quote } from "lucide-react";
import { ReviewRecord } from "@/hooks/useReviews";

const SPARK_ICON_URL =
  "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/construction_spark_icon.png";

interface ReviewCardProps {
  review: ReviewRecord;
  className?: string;
}

export function ReviewCard({ review, className = "" }: ReviewCardProps) {
  const rating = Math.max(1, Math.min(5, Number(review.rating) || 5));

  return (
    <div
      className={`flex flex-col justify-between bg-card border border-border rounded p-6 md:p-7 transition-colors duration-150 hover:border-primary/50 ${className}`}
    >
      <div>
        <div className="flex items-center justify-between gap-4 mb-4">
          <div className="flex items-center gap-1.5" aria-label={`Rating: ${rating} out of 5 stars`}>
            {[1, 2, 3, 4, 5].map((star) => (
              <img
                key={star}
                src={SPARK_ICON_URL}
                alt="Spark rating"
                className={`size-4 object-contain transition-opacity ${
                  star <= rating ? "opacity-100" : "opacity-20 grayscale"
                }`}
              />
            ))}
          </div>
          <div className="size-9 rounded bg-muted border border-border flex items-center justify-center text-primary shrink-0">
            <Quote className="size-4 rotate-180" />
          </div>
        </div>

        <p className="text-foreground font-normal text-base leading-relaxed mb-6 break-words whitespace-pre-line">
          "{review.review}"
        </p>
      </div>

      <div className="pt-4 border-t border-border flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 text-sm">
        <span className="font-medium text-foreground">
          {review.name}
        </span>
        {review.project && (
          <span className="text-muted-foreground font-mono text-xs uppercase tracking-widest">
            {review.project}
          </span>
        )}
      </div>
    </div>
  );
}
